import React from 'react';
import styled from 'styled-components';
import { FlexColumn } from '../../performance-scan/components/html';

function FriendlyTestUrl({ testUrl, flags, mainTestUrl }) {
  if (flags.includes('percolate')) {
    return (
      <Column>
        {mainTestUrl}
        <em>Percolate Optimised</em>
      </Column>
    );
  }

  return (
    <>
      {testUrl}
    </>
  );
}

FriendlyTestUrl.defaultProps = {
  flags: [],
};

const Column = styled(FlexColumn)`
  text-align: start;
`;

export default FriendlyTestUrl;
